import { NewWarrantyCaseResponseType } from "@/api/rest/models/warranty";

export type IntakeVerdict = "covered" | "notCovered";

// The line above the submit form: likely covered (by warranty or the property manager) or not. Null while still asking.
export const intakeVerdict = (status: NewWarrantyCaseResponseType | undefined): IntakeVerdict | null => {
  switch (status) {
    case NewWarrantyCaseResponseType.WARRANTY:
    case NewWarrantyCaseResponseType.PROPERTY_MANAGER_CASE:
      return "covered";
    case NewWarrantyCaseResponseType.NO_WARRANTY:
    case NewWarrantyCaseResponseType.NO_PROPERTY_MANAGER_CASE:
      return "notCovered";
    default:
      return null;
  }
};
